import { Component, Input, input, output } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { LinkField, TextField } from '@sitecore-jss/sitecore-jss-angular';
import { CardComponent } from '@legacy/common-ui-partials';
import { DisableBodyScrollingClassDirective } from '@innogy/utils-dom';

import { ModalPageHeaderComponent } from '../modal-page-header/modal-page-header.component';

@Component({
  selector: 'wl-self-service-card',
  templateUrl: './selfservice-card.component.html',
  standalone: true,
  imports: [
    DisableBodyScrollingClassDirective,
    ModalPageHeaderComponent,
    CardComponent,
  ],
})
export class SelfServiceCardComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public href?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public navigationExtras?: NavigationExtras;

  readonly isButton = input(false, {
    transform: (value: boolean | string) =>
      typeof value === 'string' ? value === '' : value,
  });
  public closeFunction = output<void>();
}
